import type { HTMLAttributes } from 'react'
import { pageTop } from './classes'

export { pageTop }

// The bottom padding varies by how the page continues.
const bottoms = {
  none: '',
  section: 'pb-5 md:pb-[50px] lg:pb-10',
  page: 'pb-20',
}

/** White band at the top of a page that holds the h1. */
export function PageHero({
  as: Tag = 'section',
  bottom = 'none',
  ...props
}: HTMLAttributes<HTMLElement> & {
  as?: 'section' | 'div'
  bottom?: keyof typeof bottoms
}) {
  return (
    <Tag className={`bg-surface ${pageTop} ${bottoms[bottom]}`} {...props} />
  )
}
